// extracted by mini-css-extract-plugin
export default {"description":"CKafKt"};